const formatPrice = price =>
  new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0 }).format(price);

export default formatPrice;
